module.exports = __webpack_public_path__ + "static/priviliges-2-b953939084dc281b3905c36b1f303da3.png";